import { LOCALES, LOCALES_LABELS } from '../../../utils/constants';
import en from './fiverr_lohp_video_en-US.vtt';
import de from './fiverr_lohp_video_de-DE.vtt';
import es from './fiverr_lohp_video_es.vtt';
import fr from './fiverr_lohp_video_fr-FR.vtt';
import it from './fiverr_lohp_video_it-IT.vtt';
import nl from './fiverr_lohp_video_nl-NL.vtt';
import pt from './fiverr_lohp_video_pt-BR.vtt';

const subtitles = [{
    src: en,
    label: LOCALES_LABELS[LOCALES.en],
    srcLang: LOCALES.en
}, {
    src: de,
    label: LOCALES_LABELS[LOCALES.de],
    srcLang: LOCALES.de
}, {
    src: es,
    label: LOCALES_LABELS[LOCALES.es],
    srcLang: LOCALES.es
}, {
    src: fr,
    label: LOCALES_LABELS[LOCALES.fr],
    srcLang: LOCALES.fr
}, {
    src: it,
    label: LOCALES_LABELS[LOCALES.it],
    srcLang: LOCALES.it
}, {
    src: nl,
    label: LOCALES_LABELS[LOCALES.nl],
    srcLang: LOCALES.nl
}, {
    src: pt,
    label: LOCALES_LABELS[LOCALES.pt],
    srcLang: LOCALES.pt
}];

export default subtitles;
